<form [formGroup]="ticketFormGroup">
  <table>
    <tbody>
      <tr>
        <td class="label">
          {{ 'common.bukTicketFormComponent.titles.language' | translate }}
        </td>
        <td>
          <mat-radio-group
            color="primary"
            formControlName="language"
            (change)="updateFormDefaultValue()"
          >
            <mat-radio-button
              color="primary"
              class="language"
              *ngFor="let language of languages"
              [value]="language"
              >{{
                'common.bukTicketFormComponent.titles.' + language | translate
              }}</mat-radio-button
            >
          </mat-radio-group>
        </td>
      </tr>
      <tr>
        <td class="label">
          {{ 'common.bukTicketFormComponent.titles.emailTitle' | translate }}
        </td>
        <td>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="emailTitle"
              [placeholder]="defaultEmailTitle"
            />
            <mat-hint *ngIf="!ticketFormGroup.get('emailTitle').value">{{
              'common.bukTicketFormComponent.messages.emptySenderEmailHint'
                | translate
            }}</mat-hint>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="label fit">
          {{ 'common.bukTicketFormComponent.titles.sender' | translate }}
        </td>
        <td class="fit">
          <div class="fields">
            <div class="field">
              <p>
                {{ 'common.bukTicketFormComponent.titles.name' | translate }}
              </p>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="sender_name"
                  [placeholder]="_senderInfo?.name"
                  (focus)="focusChange.emit('sender')"
                  (blur)="focusChange.emit()"
                />
                <mat-hint
                  *ngIf="
                    _senderInfo?.name &&
                    !ticketFormGroup.get('sender_name').value
                  "
                  >{{
                    'common.bukTicketFormComponent.messages.emptySenderNameHint'
                      | translate
                  }}</mat-hint
                >
              </mat-form-field>
            </div>

            <div class="field">
              <p>
                {{ 'common.bukTicketFormComponent.titles.email' | translate }}
              </p>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="sender_email"
                  [placeholder]="_senderInfo?.email"
                />
                <mat-hint
                  *ngIf="
                    _senderInfo?.email &&
                    !ticketFormGroup.get('sender_email').value
                  "
                  >{{
                    'common.bukTicketFormComponent.messages.emptyEmailTitleHint'
                      | translate
                  }}</mat-hint
                >
                <mat-error
                  *ngIf="
                    ticketFormGroup.get('sender_email').hasError('invalidEmail')
                  "
                  >{{
                    'common.bukTicketFormComponent.messages.emailFormatError'
                      | translate
                  }}</mat-error
                >
              </mat-form-field>
            </div>

            <div class="field">
              <p>
                {{ 'common.bukTicketFormComponent.titles.logo' | translate }}
              </p>
              <div class="image-field">
                <div
                  class="image"
                  [style.background-image]="
                    'url(' +
                    ticketFormGroup.get('sender_logo_image_url').value +
                    ')'
                  "
                >
                  <p
                    *ngIf="
                      !ticketFormGroup.get('sender_logo_image_url').value &&
                      !logoImageUploadSubscription
                    "
                  >
                    {{ 'common.messages.noImage' | translate }}
                  </p>
                  <p *ngIf="!!logoImageUploadSubscription">
                    {{ 'common.messages.uploading' | translate }}...
                  </p>
                </div>
                <app-image-input
                  #imageInput
                  (imageChange)="logoImageChanged($event)"
                ></app-image-input>
                <div class="buttons">
                  <button mat-stroked-button (click)="imageInput.startUpload()">
                    {{ 'common.actions.uploadImage' | translate }}
                  </button>
                  <button
                    mat-stroked-button
                    *ngIf="ticketFormGroup.get('sender_logo_image_url').value"
                    (click)="imageInput.reset()"
                  >
                    {{ 'common.actions.deleteLogo' | translate }}
                  </button>
                </div>
              </div>
              <p class="hint image-name" *ngIf="imageName">{{ imageName }}</p>
              <p
                class="hint"
                [innerHTML]="
                  'common.bukTicketFormComponent.messages.logoDescription'
                    | translate
                "
              ></p>
            </div>

            <mat-checkbox
              color="primary"
              formControlName="save_sender"
              class="save-checkbox"
              color="primary"
              >{{
                'common.bukTicketFormComponent.messages.infoSave' | translate
              }}</mat-checkbox
            >
          </div>
        </td>
      </tr>
      <tr>
        <td class="label">
          {{ 'common.bukTicketFormComponent.titles.receiver' | translate }}
        </td>
        <td>
          <div class="field">
            <p>
              {{ 'common.bukTicketFormComponent.titles.email' | translate }}
            </p>
            <div
              class="email-field-wrapper"
              [class.warn]="
                emailError ||
                ticketFormGroup.get('email').hasError('notEnoughCreditsError')
              "
            >
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="chip-list"
              >
                <mat-chip-list #chipList>
                  <ng-container *ngFor="let email of emails; let i = index">
                    <mat-chip
                      *ngIf="!isEmailCollapsed || i < 5"
                      [selectable]="true"
                      [removable]="true"
                      (removed)="onEmailChipRemoved(email)"
                      (click)="onEmailChipClick()"
                      #chip
                    >
                      {{ email }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
                  <mat-chip
                    *ngIf="isEmailCollapsed && emails.length > 5"
                    [selectable]="false"
                    (click)="onEmailChipClick()"
                  >
                    {{
                      'cp.MORE_EMAIL' | translate: { more: emails.length - 5 }
                    }}
                  </mat-chip>
                  <span>
                    <input
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="_separatorKeysCodes"
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="onEmailChipInputTokenEnd($event)"
                      (focus)="onEmailInputFocus()"
                      (paste)="onEmailPaste($event)"
                      (blur)="onEmailInputBlur()"
                      (input)="emailInputChange$.next($event)"
                    />
                  </span>
                </mat-chip-list>
              </mat-form-field>
              <button
                mat-stroked-button
                (click)="$event.stopPropagation(); fileUpload.click()"
                angulartics2On
                angularticsAction="click_import_ticket_emails"
                [angularticsLabel]="gaTrackingId"
              >
                {{
                  'common.bukTicketFormComponent.actions.importFiles'
                    | translate
                }}
              </button>
              <input
                #fileUpload
                style="display: none"
                type="file"
                multiple
                (change)="onFileChange($event.target.files)"
                accept=".txt,.csv,.xlsx,.xls"
              />
            </div>
            <p class="error" *ngIf="emailError">
              {{
                'common.bukTicketFormComponent.messages.emailFormatError'
                  | translate
              }}
            </p>
            <p
              class="error"
              *ngIf="
                ticketFormGroup.get('email').hasError('notEnoughCreditsError')
              "
            >
              {{
                'common.bukTicketFormComponent.messages.chargePermissionDenied'
                  | translate
              }}
            </p>
            <p
              class="hint fit"
              [innerHTML]="
                'common.bukTicketFormComponent.messages.emailFileDescription'
                  | translate
              "
            ></p>
          </div>
        </td>
      </tr>
      <tr *ngIf="!_isUnlimitedTicket">
        <td class="label center">
          {{ 'common.bukTicketFormComponent.titles.expiryDate' | translate }}
        </td>
        <td class="center">
          <div class="expiry-date-field-wrapper">
            <mat-form-field class="select">
              <mat-select
                formControlName="expiryDate"
                (selectionChange)="isDatePickerMode = false"
                (focus)="focusChange.emit('expiryDate')"
                (blur)="focusChange.emit()"
              >
                <mat-option
                  *ngFor="let expiryDate of expiryDates"
                  [value]="expiryDate"
                  >{{ expiryDate | periodTranslate }}</mat-option
                >
                <mat-option (click)="openDatePicker()">
                  {{
                    'common.bukTicketFormComponent.titles.datepicker'
                      | translate
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="datepicker"
              [class.hidden]="!isDatePickerMode"
            >
              <input
                matInput
                [matDatepicker]="picker"
                (dateChange)="updateExpiryDate($event.value)"
                [min]="minDate"
                [max]="maxDate"
              />
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </td>
      </tr>
      <tr *ngIf="!_isUnlimitedTicket">
        <td class="label fit center">
          {{ 'common.bukTicketFormComponent.titles.period' | translate }}
        </td>
        <td class="fit center">
          <mat-form-field class="select">
            <mat-select
              formControlName="period"
              (focus)="focusChange.emit('period')"
              (blur)="focusChange.emit()"
            >
              <mat-option *ngFor="let period of periods" [value]="period">{{
                period | periodTranslate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="label">
          {{ 'common.bukTicketFormComponent.titles.message' | translate }}
        </td>
        <td>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              #message
              maxlength="{{ messageMaxlength }}"
              rows="6"
              formControlName="message"
              [placeholder]="defaultEmailMessage"
              (focus)="focusChange.emit('message')"
              (blur)="focusChange.emit()"
            ></textarea>
            <mat-hint
              >{{
                'common.bukTicketFormComponent.messages.messageDescription'
                  | translate
              }}
              ({{ message.value.length || 0 }}/{{ messageMaxlength }})</mat-hint
            >
          </mat-form-field>
        </td>
      </tr>
    </tbody>
  </table>
</form>
